var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar__badge"},[_c('div',{staticClass:"avatar__badge__outer",style:({ width: `${_vm.width}`, height: `${_vm.height}` })}),_c('div',{staticClass:"avatar__badge__inner",class:{ 'avatar__badge__inner--not': !_vm.connected },style:({ width: `${_vm.width}`, height: `${_vm.height}` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }